<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="formGroup"
    #form="ngForm"
    onsipFormTracking
    name="admin-phone-lines-edit"
    id="admin-phone-lines-edit"
    (ngSubmit)="submit()"
  >
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <section>
          <div class="expansion-title">
            <span class="mat-body-1 span-with-icon">
              Expansion module
              <mat-icon
                class="question-hover-icon"
                onsip-question-mark-tooltip
                matTooltipClass="onsip-tooltip-background"
                matTooltip="An expansion module is a physical attachment that adds additional phone lines."
                matTooltipPosition="above"
              >
                help_outline
              </mat-icon>
            </span>
          </div>
          @if (expansionModuleName) {
          <div>
            <mat-radio-group
              class="expansion-radio-group"
              color="primary"
              formControlName="expansionModule"
            >
              <mat-radio-button [value]="false">None</mat-radio-button>
              <mat-radio-button [value]="true">{{
                expansionModuleName || "None"
              }}</mat-radio-button>
            </mat-radio-group>
          </div>
          } @else {
          <div class="no-expansion">
            Expansion module is unavailable for your phone’s make and model. To see which makes and
            models feature expansion modules,
            <a class="support-link" href="https://support.onsip.com" target="_blank"
              >visit the knowledgebase.</a
            >
          </div>
          }
        </section>
      </div>
      <div class="second-column" formGroupName="linesInfo">
        <section class="lines-edit-users">
          <div class="mat-body-1 total-lines">Lines ({{ lineOptions.length }} available)</div>
          @for (line of lineOptions; track line; let i = $index; let first = $first; let isLast =
          $last) {
          <div class="lines-grid onsip-grid-placement">
            <div class="lines-select-address">
              <div class="mat-body-1 m-b-12">{{ getLineName(i) }}</div>
              <onsip-address-autocomplete
                [addressTypes]="['user']"
                noneSelectedMessage="Not assigned"
                [parentForm]="form"
                [formControlName]="'nameLine' + (i + 1)"
                [preventBrowse]="true"
                [errorMessage]="getLineError(i + 1)"
              >
              </onsip-address-autocomplete>
            </div>
            <div class="lines-edit-controls onsip-grid-placement">
              <mat-radio-group
                formControlName="typeLine{{ i + 1 }}"
                (change)="handleLineChange($event, i)"
                class="lines-edit-radio-group"
                color="primary"
              >
                @if (line.type !== 'blf') {
                <mat-radio-button value="Phone line">Phone line</mat-radio-button>
                } @if (line.type !== 'phone') {
                <mat-radio-button value="Busy lamp">Busy Lamp</mat-radio-button>
                }
              </mat-radio-group>
              @if (isPolycomPhone) { @if (first || (getLinesControl(i + 1) && !getLinesControl(i +
              1).disabled)) { @if (!line.isExpansion && line.type !== 'blf') {
              <mat-checkbox color="primary" formControlName="callWaitingLine{{ i + 1 }}"
                >Call waiting</mat-checkbox
              >
              } } @if (!first && (getLinesControl(i + 1) && getLinesControl(i + 1).disabled)) { @if
              (!line.isExpansion && line.type !== 'blf') {
              <mat-checkbox [disabled]="true" color="primary">Call waiting</mat-checkbox>
              } } }
            </div>
            @if (!isLast) {
            <mat-divider></mat-divider>
            }
          </div>
          }
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button
        mat-button
        type="button"
        class="toggle-button"
        color="primary"
        (click)="toggleLinePanel()"
      >
        Cancel
      </button>
      <button mat-flat-button type="submit" class="toggle-button" color="primary">
        Save Changes
      </button>
    </div>
  </form>
</onsip-loading-container>
